import { render, staticRenderFns } from "./PreDigitalSignContract.vue?vue&type=template&id=6c8ff3d1&scoped=true"
import script from "./PreDigitalSignContract.vue?vue&type=script&lang=js"
export * from "./PreDigitalSignContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ff3d1",
  null
  
)

export default component.exports